import { AppointmentType, EnhancedAppointment } from '@bb/domain/dist/types';
import { Button as _Button, Icon } from 'components';
import type { FeedbackModalMode } from 'contexts/modal/types';
import React from 'react';
import styled from 'styled-components';
import { FEEDBACK_TYPES } from '@/constants';

export type FeedbackEntryProps = Pick<
  EnhancedAppointment,
  'feedbackCollected' | 'status'
> & {
  isBuyer: boolean;
  onClick: (feedbackMode: FeedbackModalMode) => void;
  passed: boolean;
  isMobile?: boolean;
  type: AppointmentType | 'APPOINTMENT' | 'ROUTE_STOP';
};

const DEFAULT_ICON_PROPS = {
  width: 12,
  height: 12,
};

const FeedbackEntry: React.FC<FeedbackEntryProps> = ({
  feedbackCollected,
  isBuyer,
  onClick,
  passed,
  status,
  type,
  isMobile,
}) => {
  const isAcceptingFeedback = FEEDBACK_TYPES.includes(type);
  const isConfirmedAndInPast = status === 'confirm' && passed;
  if (!isAcceptingFeedback || !isConfirmedAndInPast) return null;
  let text;
  let icon;
  const Button = isMobile ? MobileButton : _Button;
  const feedbackMode: FeedbackModalMode = feedbackCollected ? 'view' : 'record';
  if (feedbackMode === 'view') {
    text = `Feedback ${isBuyer ? 'sent' : 'received'}`;
    icon = (
      <Icon
        type="check"
        {...DEFAULT_ICON_PROPS}
        offset={[0, -1]}
        color="primary"
      />
    );
  } else {
    text = isBuyer ? 'Give feedback' : 'Ask for feedback';
  }
  return (
    <Button
      type="link"
      size="small"
      underlineOnHover
      icon={icon}
      onClick={e => {
        e.stopPropagation();
        onClick(feedbackMode);
      }}
      data-cy="showing-feedback-button"
    >
      {text}
    </Button>
  );
};

const MobileButton = styled(_Button)`
  padding: 0;
`;

export default FeedbackEntry;
